/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AsyncMergeJobObject { 
    jobId: string;
    status: AsyncMergeJobObject.StatusEnum;
    result?: object;
    error?: object;
    errorCode?: string;
    createdAt: string;
    completedAt?: string;
}
export namespace AsyncMergeJobObject {
    export type StatusEnum = 'IN_PROGRESS' | 'COMPLETED' | 'FAILED' | 'UNKNOWN';
    export const StatusEnum = {
        InProgress: 'IN_PROGRESS' as StatusEnum,
        Completed: 'COMPLETED' as StatusEnum,
        Failed: 'FAILED' as StatusEnum,
        Unknown: 'UNKNOWN' as StatusEnum
    };
}


